import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const FEBRUARY_2025_CAMPAIGN_END_DATE = d(2025, 3, 7, 12, 0);
